import React, { useId } from 'react';


/**
 * Small flame glyph used as the "this card will burn" indicator on the
 * river and the guest deck grid. Sizing and positioning come from the
 * className the caller passes in (e.g. `tradelane-will-burn` /
 * `deck-grid-card-will-burn`); this component only renders the glyph.
 *
 * The radial gradient id is per-instance via `useId` so multiple
 * <FireIcon/> in the same document never collide on `<defs>` ids.
 */
export default function FireIcon({ className, style, title }) {
    const gradientId = useId();
    return (
        <svg className={className}
             style={style}
             viewBox="0 0 20 20"
             xmlns="http://www.w3.org/2000/svg"
             role={title ? 'img' : 'presentation'}
             aria-hidden={title ? undefined : true}>
            {title && <title>{title}</title>}
            <defs>
                <radialGradient id={gradientId} cx="50%" cy="70%" r="65%">
                    <stop offset="0%" stopColor="#fff4b8"/>
                    <stop offset="40%" stopColor="#ff9a1f"/>
                    <stop offset="100%" stopColor="#c8170a"/>
                </radialGradient>
            </defs>
            <path
                fill={`url(#${gradientId})`}
                stroke="#5a0a02"
                strokeWidth="0.5"
                strokeLinejoin="round"
                d="M12.395 2.553a1 1 0 0 0-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.4 31.4 0 0 0-.613 3.58 2.64 2.64 0 0 1-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 0 0 5.05 6.05 6.981 6.981 0 0 0 3 11a7 7 0 1 0 11.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 0 1 7 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A3 3 0 0 1 12.12 15.12z"
            />
        </svg>
    );
}
